<div class="row sub-section-title">
    <div class="col-12">
        <img src="/assets/images/icons/refresh_blue.svg" />
        <span>Funding pending ...</span>
    </div>
</div>